<template>
  <!-- Root element keeps the caller's class so the footer's existing `.text`
       rule still styles it — Vue 2 scoped CSS applies the parent's scope id to
       a child component's root node. -->
  <!-- Just the Appointed Representative sentence, for a caller that wraps it in
       its own paragraph (the trust cards). Same string as the `page` variant. -->
  <span v-if="variant === 'inline'">{{ arrangedBy }}</span>
  <div v-else-if="variant === 'footer'" class="text">
    Copyright ©{{ year }} Pedalsure*. All rights reserved. Dukes House Insurance
    Limited is a company registered in the Bailiwick of Guernsey under the
    Companies (Guernsey) Law 2008 (Company number {{ COMPANY_NUMBER }}) and is
    authorised and regulated by the Guernsey Financial Services Commission.
    Registration Number {{ GFSC_NUMBER }}. Dukes House Insurance Limited is not
    party to the UK Financial Services Compensation Scheme.
    <br />
    <br />
    Your policy is arranged by Pedalsure No3 Limited with Dukes House Insurance
    Limited. Pedalsure No3 Limited is an Appointed Representative of Pro MGA
    Solutions Ltd which is authorised and regulated by the Financial Conduct
    Authority under reference {{ FCA_REFERENCE }}. Pedalsure No3 Limited and
    Dukes House Insurance Limited are under common ownership.
  </div>
  <div v-else-if="variant === 'detailed'" class="ps-regulatory">
    <p>
      Your policy is arranged by Pedalsure No3 Limited, Suite 3 Dukes House, 4–6
      High Street, Windsor SL4 1LD. Pedalsure No3 Limited is an Appointed
      Representative of Pro MGA Solutions Ltd, which is authorised and regulated
      by the Financial Conduct Authority under reference
      {{ FCA_REFERENCE }}.
    </p>
    <p>
      Your policy is underwritten by Dukes House Insurance Limited, PO Box 155,
      Mill Court, La Charroterie, St Peter Port, Guernsey GY1 4ET. It is
      registered in the Bailiwick of Guernsey under the Companies (Guernsey) Law
      2008, company number {{ COMPANY_NUMBER }}, and is authorised and regulated
      by the Guernsey Financial Services Commission, registration number
      {{ GFSC_NUMBER }}.
    </p>
    <p>
      Dukes House Insurance Limited is not party to the UK Financial Services
      Compensation Scheme.
    </p>
    <p>
      Pedalsure No3 Limited and Dukes House Insurance Limited are under common
      ownership.
    </p>
  </div>
  <div v-else class="ps-regulatory">
    <p>Pedalsure has been insuring cyclists since 2014. {{ arrangedBy }}</p>
    <p>
      Your cover is underwritten by Dukes House Insurance Limited, registered in
      the Bailiwick of Guernsey (company number {{ COMPANY_NUMBER }}) and
      authorised and regulated by the Guernsey Financial Services Commission,
      registration number {{ GFSC_NUMBER }}. Dukes House Insurance Limited is
      not party to the UK Financial Services Compensation Scheme.
    </p>
  </div>
</template>

<script>
// The sitewide regulatory disclosure, in one file.
//
// Two renderings, deliberately: `footer` is the small print at the bottom of
// every page, `page` is the "Who we are and who insures you" section the hub
// pages carry. The wording of the two is not identical — the footer's has been
// signed off as it stands and the hub copy was written separately — but the
// registration numbers are the one thing that must never drift, so they are
// declared once here and interpolated into both. Change a number and both
// renderings change together.
export default {
  name: 'RegulatoryStatement',
  props: {
    variant: {
      type: String,
      default: 'page',
      validator: (value) =>
        ['footer', 'page', 'detailed', 'inline'].includes(value),
    },
  },
  data() {
    return {
      FCA_REFERENCE: '770419',
      COMPANY_NUMBER: '66539',
      GFSC_NUMBER: '2522730',
    }
  },
  computed: {
    // Rendered by both `page` and `inline`, so the two cannot drift.
    arrangedBy() {
      return (
        'Your policy is arranged by Pedalsure No3 Limited, an Appointed ' +
        'Representative of Pro MGA Solutions Ltd, which is authorised and ' +
        'regulated by the Financial Conduct Authority under reference ' +
        `${this.FCA_REFERENCE}.`
      )
    },
    year() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style lang="scss" scoped>
.ps-regulatory {
  p {
    font-size: $ps-text-small;
    line-height: 1.6;
    color: $ps-body-color;
  }
  p + p {
    margin-top: 14px;
  }
}
</style>
